var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gl-list-none gl-p-0"},_vm._l((_vm.projects),function(project){return _c('projects-list-item',{key:project.id,class:_vm.listItemClass,attrs:{"project":project,"show-project-icon":_vm.showProjectIcon,"timestamp-type":_vm.timestampType},on:{"delete":function($event){return _vm.$emit('delete', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }